const TERMS = [
  ['사전 리허설', 'rehearsal', '공식 시작 전 실제 모델과 근거 저장을 시험하는 단계'],
  ['공식 관찰', 'official Stage A', '4-8주 동안 운영 무결성을 세는 공식 기간'],
  ['기록 묶음', 'cohort', '같은 조건으로 만든 실행 기록 그룹'],
  ['자동 실행', 'scheduler', '정해진 시간에 시스템이 스스로 실행하는 기능'],
  ['근거 묶음', 'evidence snapshot', '판단에 사용한 뉴스·시세·프롬프트 저장본'],
  ['가상 장부', 'virtual ledger', '실제 주문 없이 손익과 포지션을 기록하는 장부'],
];

export default function Atu2Glossary() {
  return (
    <section className="atu2-panel">
      <div className="atu2-section-head">
        <div>
          <span className="atu2-kicker">용어</span>
          <h2>쉬운 말과 내부 용어</h2>
        </div>
        <p>화면은 쉬운 말을 먼저 쓰고, 문서·로그 추적용 내부 용어를 함께 둡니다.</p>
      </div>
      <div className="atu2-glossary">
        {TERMS.map(([label, internal, detail]) => (
          <div className="atu2-term" key={internal}>
            <strong>{label}</strong>
            <code>{internal}</code>
            <span>{detail}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
